<template>
  <v-layout @mouseleave="showDropDown = false"
            row
            justify-space-between
            class="action-row"
            :class="[item.hidden ? 'disabled' : '']">

    <div class="action-row-icon">
      <span :class="item.icon"/>
    </div>

    <v-layout class="inner-wrapper">

      <div class="action-row-title">
        {{item.label}}
      </div>

      <div class="contact-details"
           v-if="isContactField">
        <span class="contact-details-icon icon-client-card"/>
        <span class="contact-details-text">
        {{$t('settings.client_card.contact_details')}}
        </span>
      </div>

      <div class="action-icon-wrapper">
        <div v-if="rowActions && item.hidden"
             class="action-icon icon-Temp_Hide"/>

        <div v-if="rowActions"
             @click="openDropDown($event)"
             class="action-icon icon-dots-three-vertical"/>

        <v-list v-click-outside="closeDropDown"
                v-if="showDropDown && (editMenuToShow === item.id || editMenuToShow === item.new_id)">
          <v-list-item-group color="primary">
            <v-list-item v-for="(action, i) in rowActions"
                         :key="i"
                         @click="actionClicked($event,action.action,item)">
              <v-list-item-content>
                <v-list-item-title v-html="action.label"/>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

      </div>

    </v-layout>

  </v-layout>
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "ActionRow",
    directives: {
      ClickOutside
    },
    props: ['item', 'actions', 'editMenuToShow'],
    data() {
      return {
        showDropDown: false,
        rowActions: []
      }
    },
    updated() {
      if (this.item.actions) {
        this.rowActions = this.item.actions;
      } else {
        this.rowActions = this.actions;
      }
    },
    watch: {
      editMenuToShow(val) {
        this.editMenuToShow = val;
      }
    },
    computed: {
      isContactField() {
        return this.item.object_type === 'contact';
      }
    },
    methods: {
      actionClicked($event,action,item) {
        this.$emit('actionRowClicked', action, item, $event);
        this.showDropDown = false;
      },
      openDropDown(event) {
        event.stopPropagation();
        this.$emit("editMenuToShow", this.item);
        this.showDropDown = true;
      },
      closeDropDown() {
        this.showDropDown = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/abstract/_variables.scss";
  @import "../../../assets/scss/abstract/_mixins.scss";

  .rtl .v-list {
    right: unset !important;
    left: 0;
  }

  .action-row {
    width: 540px;
    height: 60px;
    border-radius: 4px;
    border: solid 1px rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    font-family: var(--font3);
    font-size: 14px;
    cursor: pointer;
    margin: 0;
    font-weight: 600;
    color: $color_dark_text;
    position: relative;

    &.disabled {
      color: rgba(0, 0, 0, 0.12);

      .action-row-icon {
        background-color: rgba(0, 0, 0, 0.12);
      }
    }

    :hover {
      background-color: #f1f3f8;

      .icon-Temp_Hide {
        display: none;
      }

      span {
        background-color: transparent;
      }
    }

    .action-row-icon {
      width: 58px;
      height: 58px;
      @include i-border-radius(4px, 0, 0, 4px);
      background-color: rgba(0, 0, 0, 0.27);
      color: #ffffff;
      text-align: center;
      font-size: 20px;
      line-height: 60px;
    }

    .inner-wrapper {
      margin: 0;
      position: relative;

      .action-row-title {
        margin: 2px 10px;
        line-height: 54px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 320px;
      }

      .action-icon-wrapper {
        position: absolute;
        @include i-position-mirror(right, 0);

        .action-icon {
          width: 28px;
          height: 28px;
          border-radius: 20px;
          font-size: 22px;
          text-align: center;
          line-height: 27px;
          margin: 16px 18px 0 18px;
          cursor: pointer;
        }
      }

      .icon-dots-three-vertical {
        display: none;
      }

      .icon-Temp_Hide {
        color: #999999;
      }

      .v-list {
        width: 180px;
        font-size: 13px;
        font-weight: 400;
        color: $color_dark_text;
        position: absolute;
        z-index: 1;
        @include i-position-mirror(right, 0);
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);

        .v-list-item__title {
          font-size: 13px;
        }

        .v-list-item {
          min-height: 40px;
        }
      }

      .contact-details {
        position: relative;
        top: 15px;
        @include i-text-align(left);
        color: $color_dark_sec_text;
        font-size: 14px;
        font-weight: normal;

        &-icon {
          font-size: 21px;
          position: relative;
          top: 4px;
          color: $color_dark_text;
        }

        &:hover {
          background-color: transparent;
        }
      }

      &:hover {

        .icon-dots-three-vertical {
          display: block;
        }
      }
    }

    @include sm-and-down {

      .inner-wrapper {
        width: 50%;

        .action-row-title {
          max-width: 189px;
        }

        .icon-dots-three-vertical {
          display: block;
        }

        .icon-Temp_Hide {
          display: none;
        }

        .action-icon {
          margin-top: 17px;
          @include i-margin-mirror(10px, 0);
        }

        .contact-details {

          &-text {
            display: none;
          }

          &-icon {
            font-size: 20px;
            @include i-margin-mirror(-4px, 0);
          }
        }
      }
    }
  }

</style>
